'use client';
import { ListItemIconStyled } from './list-item-icon-styles';

const ListItemIcon = ListItemIconStyled;

export default ListItemIcon;
